module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.logosCount > 1) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("SELECT A LOGO OPTION")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row no-gutter"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row no-gutter"
  }, [_c('label', {
    staticClass: "col-sm-6 control-label"
  }, [_vm._v("Select a preferred logo on your brick:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    class: {
      'has-error': _vm.errors.has('preferred_logo')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prefLogo),
      expression: "prefLogo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "preferred_logo",
      "data-vv-name": "preferred_logo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.prefLogo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.onChange(_vm.prefLogo)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Please select a logo --")]), _vm._v(" "), _vm._l((_vm.logosList), function(logo, logoIndex) {
    return _c('option', {
      domProps: {
        "value": logoIndex
      }
    }, [_vm._v("\n                            " + _vm._s(logo.brief_descr) + "\n                        ")])
  })], 2)])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-baeeb78e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/preferred-logo.vue
// module id = qEXq
// module chunks = 1